/* A wrapper components that wraps every page on this site via <gatsby-plugin-layout.
 * This component stores all of the context for the mobile and desktop navigation bars.
 *
 * It's responsible for placing the mobile and desktop navbars and <Footer /> on each page.
 * https://www.npmjs.com/package/gatsby-plugin-layout
 *
 * Emotion's global component: https://emotion.sh/docs/globals
 */

import * as React from 'react';
import { useState, useMemo, useCallback } from 'react';
import { Global } from '@emotion/react';
import { useStaticQuery, graphql, Link } from 'gatsby';

import Icon from '@components/utils/IconWrap';
import Footer from './nav/Footer';
import NavBarContext from '../contexts/NavBarContext';
import wwwApconCom from '../www.apcon.com';
import TopNav3 from './nav/TopNav3';
// import globalCSS from './PageWrapperCSS';

// Add global CSS styles to this variable below

export default function PageWrapper(props) {
  const { children } = props;
  const [fullscreenMenuIsOpen, setfullscreenMenuIsOpen] = useState(false);
  const [menu, setMenu] = useState('Hardware');
  const [product, setProduct] = useState('datacenterHardware');

  // Get all of the images in src/assets/images/navbar and resources in src/pages/resources
  const data = useStaticQuery(graphql`
    {
      productPhotos: allFile(
        filter: {
          absolutePath: { regex: "/assets/images/apcon-product-photos/" }
        }
      ) {
        edges {
          node {
            childCloudinaryAsset {
              gatsbyImageData
            }
          }
        }
      }

      navBarImages: allFile(
        filter: { absolutePath: { regex: "/assets/images/navbar/" } }
      ) {
        edges {
          node {
            childCloudinaryAsset {
              gatsbyImageData
            }
          }
        }
      }

      resources: allMdx(
        filter: {
          frontmatter: {
            published: { eq: true }
            contentType: { eq: "Resources" }
          }
        }
      ) {
        edges {
          node {
            frontmatter {
              title
              file {
                publicURL
              }
              dateFormatted: date(formatString: "MMMM Do, YYYY")
              dateIso: date
              reviewDateFormatted: reviewDate(formatString: "MMMM Do, YYYY")
              reviewDateIso: reviewDate
              gatedContentURL
              productFamily
              type
              alt
              thumbnail {
                childCloudinaryAsset {
                  gatsbyImageData
                }
              }
            }
          }
        }
      }
    }
  `);

  const productPhotos = data.productPhotos.edges;
  const navBarImgs = data.navBarImages.edges;

  const navBarImages = useMemo(
    () => [...productPhotos, ...navBarImgs],
    [productPhotos, navBarImgs]
  );

  const resources = data.resources.edges;

  const openFullscreenMenu = useCallback(() => {
    setfullscreenMenuIsOpen(true);
  }, [setfullscreenMenuIsOpen]);

  const closeFullscreenMenu = useCallback(() => {
    setfullscreenMenuIsOpen(false);
  }, [setfullscreenMenuIsOpen]);

  // Memoize a.k.a. "cache" the functions and state values so that they aren't called on every render
  const memoizedValue = useMemo(
    () => ({
      fullscreenMenuIsOpen,
      openFullscreenMenu,
      closeFullscreenMenu,
      menu,
      setMenu,
      product,
      setProduct,
      navBarImages,
      resources,
    }),
    [
      fullscreenMenuIsOpen,
      openFullscreenMenu,
      closeFullscreenMenu,
      menu,
      setMenu,
      product,
      setProduct,
      navBarImages,
      resources,
    ]
  );

  return (
    <>
      <Global />
      <NavBarContext.Provider value={memoizedValue}>
        <div className="bg-primary hidden lg:block">
          <div className="px-4">
            <div className="flex flex-col lg:flex-row items-center justify-center gap-4 py-2">
              <div className="flex items-center gap-3">
                <div className="size-6">
                  <Icon
                    icon="fluent:megaphone-loud-24-filled"
                    className="text-primary-content"
                  />
                </div>
                <p className="text-sm font-semibold text-primary-content">
                  IntellaView Enterprise Lite - Now Available
                </p>
              </div>
              <Link
                to={wwwApconCom.intellaview.enterpriseLite}
                className="inline-flex items-center justify-center whitespace-nowrap rounded-full bg-white px-3 py-1 text-sm font-semibold text-primary shadow-sm transition-all hover:bg-white/90 hover:text-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
              >
                Explore Features
              </Link>
            </div>
          </div>
        </div>
        <TopNav3 />
        {/* <MobileNavBar pathname={pathname} /> */}
        <div
          className="text-base-content theme-test"
          style={{
            backgroundColor: 'var(--color-base-100)',
            color: 'var(--color-base-content)',
          }}
        >
          {children}
        </div>
        <Footer />
      </NavBarContext.Provider>
    </>
  );
}
